import { render, staticRenderFns } from "./AbkAttachmentsBox.vue?vue&type=template&id=638a3c85&scoped=true&"
import script from "./AbkAttachmentsBox.vue?vue&type=script&lang=js&"
export * from "./AbkAttachmentsBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkAttachmentsBox.vue?vue&type=style&index=0&id=638a3c85&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a3c85",
  null
  
)

export default component.exports